import { Button, Stack, Box } from "@mui/material";
import { useContext } from "react";
import { Form, FormContext } from "components/shared/Form";
import UserField from "components/ui/atoms/formFields/UserField";

const asArray = (obj) => {
  return Array.isArray(obj) ? obj : obj ? [obj] : [];
};

const NoteFilterFormFields = () => {
  const { onSubmit } = useContext(FormContext);

  return (
    <Stack spacing={2}>
      <UserField name="owner" label="Owner" multiple />
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button variant="contained" onClick={onSubmit}>
          Apply
        </Button>
      </Box>
    </Stack>
  );
};

const prepareInitialValues = (object) => ({
  owner: asArray(object?.owner),
});

const NoteFilterForm = (props) => {
  return (
    <Form prepareInitialValues={prepareInitialValues} {...props}>
      <NoteFilterFormFields />
    </Form>
  );
};

export default NoteFilterForm;
